const settings = {
  title: '추가 기능',
  data: [
    {
      name: 'privacy',
      title: '개인정보 처리방침',
      disabled: false,
      avatar: 'https://cdn-icons-png.flaticon.com/512/1809/1809812.png',
      description:
        '필요한 항목들을 설정하여 개인정보 처리방침을 간편하게 자동 생성해보세요.',
    },
    {
      name: 'slack',
      title: 'Slack 연동',
      disabled: true,
      avatar:
        'https://www.itprotoday.com/sites/itprotoday.com/files/appIcon_desktop.png',
      description:
        '새로운 사용자가 가입할 때마다 Slack 채널에서 메세지를 받아보세요.',
    },
    {
      name: 'multifactor',
      title: 'Multi-Factor 인증',
      disabled: true,
      avatar:
        'https://static.vecteezy.com/system/resources/previews/002/997/158/non_2x/multi-factor-authentication-gradient-linear-icon-vector.jpg',
      description:
        '다양한 인증 방법을 함께 적용하여 서비스의 보안성을 향상시켜보세요.',
    },
    {
      name: 'cloudflare',
      title: 'Cloudflare 연동',
      disabled: true,
      avatar:
        'data:image/png;base64,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',
      description:
        'Cloudflare를 연동하여 공용 네트워크에 노출된 리소스를 안전하게 관리해보세요.',
    },
    {
      name: 'selfAuth',
      title: '본인 인증',
      disabled: true,
      avatar: 'https://cdn-icons-png.flaticon.com/512/3680/3680014.png',
      description:
        '본인 인증 수단을 추가하여 중복 가입을 방지하세요. 해커의 계정 탈취로부터 안전해집니다.',
    },
  ],
};

export default settings;
